<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <!-- LOGIN FORM -->
      <div class="account-wrapper">
        <h3 class="account-title">Forgot Password</h3>
        <hr />
        <form @submit.prevent="submit">
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <p class="text-success text-center" v-if="successMessage">
            {{ successMessage }}
          </p>
          <div class="form-group">
            <label>Email</label>
            <input
              class="form-control"
              type="email"
              v-model="email"
              maxlength="100"
              required
            />
          </div>
          <div class="form-group">
            <label>Code</label>
            <div class="row align-items-center">
              <div class="col-5">
                <input
                  class="form-control"
                  type="text"
                  v-model="code"
                  maxlength="4"
                  required
                />
              </div>
              <div class="col-5 noselect">
                <input
                  type="text"
                  readonly
                  id="generated-captcha"
                  :value="captcha"
                />
                <img
                  border="0"
                  src="/static/icon_refresh.png"
                  style="cursor: pointer"
                  title="Refresh Code"
                  class="ml-2"
                  @click="generateCaptcha"
                />
              </div>
            </div>
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Submit
            </button>
          </div>
          <div class="form-group text-center mb-1">
            <router-link :to="{ name: 'mainAdminLogin' }">
              Back to login
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      errorMessage: "",
      successMessage: "",
      email: "",
      code: "",
      captcha: "",
    };
  },
  methods: {
    reset() {
      this.email = "";
      this.code = "";
      this.generateCaptcha();
    },
    generateCaptcha() {
      let characters =
        "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz123456789";
      let first = characters[Math.floor(Math.random() * characters.length)];
      let second = characters[Math.floor(Math.random() * characters.length)];
      let third = characters[Math.floor(Math.random() * characters.length)];
      let fourth = characters[Math.floor(Math.random() * characters.length)];
      this.captcha =
        first.toString() +
        second.toString() +
        third.toString() +
        fourth.toString();
    },
    submit() {
      this.errorMessage = "";
      this.successMessage = "";
      if (this.code !== this.captcha) {
        this.errorMessage = "Please fill the correct code";
        this.reset();
        return;
      }
      this.$store.state.isLoading = true;
      API.mainAdmin
        .sendForgotPasswordEmail({ Email: this.email })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.$swal(response.data.message, {
              icon: "success",
            });
            this.$router.push({ name: "mainAdminLogin" });
          } else {
            this.errorMessage = response.data.message;
          }
          this.reset();
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.errorMessage = error;
          this.reset();
        });
    },
  },
  created() {
    this.generateCaptcha();
  },
};
</script>

<style scoped>
.container {
  background: url("/static/bg-image.jpg") no-repeat center fixed;
  background-size: cover;
  -webkit-background-size: cover;
  max-width: 100%;
  height: 100%;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

#generated-captcha {
  pointer-events: none;
  height: 33px;
  width: 70px;
  text-align: center;
  font-size: 17px;
  background-color: black;
  border-radius: 6px;
  border: none;
  padding: 6px;
  outline: none;
  color: lightgrey;
}
</style>


// WEBPACK FOOTER //
// src/components/MainAdmin/ForgotPassword.vue